import { render, staticRenderFns } from "./marketingList.vue?vue&type=template&id=9392a6b8&scoped=true&"
import script from "./marketingList.vue?vue&type=script&lang=js&"
export * from "./marketingList.vue?vue&type=script&lang=js&"
import style0 from "./marketingList.vue?vue&type=style&index=0&id=9392a6b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9392a6b8",
  null
  
)

export default component.exports